module.exports = __webpack_public_path__ + "static/Highlight4-b898854588fa4bc34623f95c51b03541.png";